import { render, staticRenderFns } from "./staff-cake.vue?vue&type=template&id=6b06dd54"
import script from "./staff-cake.vue?vue&type=script&lang=tsx"
export * from "./staff-cake.vue?vue&type=script&lang=tsx"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports